export default __webpack_public_path__ + "static/media/self-contained.e487fb29.svg";